import merchantLogo from "@/assets/icons/iconsax/3dcube.svg";
import { Stepper, Tabs } from "@/components";
import { useStepper } from "@/components/stepper/Stepper";
import { platforms } from "@/utils/constants";

import {
    MerchantForm,
    RemitaFormMarkup,
    PaystackFormMarkup,
    InterswitchMarkup,
    DreamLabsFormMarkup,
    PayProFormMarkup,
    PayProKanoFormMarkup,
    SokotoIRSFormMarkup,
} from "./MerchantForms";

import { useProductIntegration, MerchantConfigurationContext } from "../productIntegrationUtils";
import { ContentBaseWrapper } from "./productIntegrationStyles";
import {
    remitaFormValidation,
    paystackFormValidation,
    dreamlabsFormValidation,
    payproFormValidation,
    payproKanoFormValidation,
    sokotoIrsFormValidation,
    asParameterSchema,
} from "../productIntegrationValidation";
import { useToggle } from "react-use";

const platformToTabIndex = {
    [platforms.REMITA]: 0,
    [platforms.PAYSTACK]: 1,
    [platforms.INTERSWITCH]: 2,
    [platforms.DREAMLABS]: 3,
    [platforms.PAYPRO]: 4,
    [platforms.PAYPRO_KANO]: 5,
    [platforms.SOKOTO_IRS]: 6,
};

export default function MerchantConfiguration() {
    const { values, addToValues } = useProductIntegration();
    const { handleNext } = useStepper();
    const [isReadyToSubmit, toggleIsReadyToSubmit] = useToggle();
    const [warn, toggleWarn] = useToggle();
    const handleTabChange = ({ indexKey }) => {
        addToValues({ platform: indexKey });
    };

    const handleNextClick = () => {
        if (values.platform === platforms.INTERSWITCH) {
            handleNext();
            return;
        }
        toggleIsReadyToSubmit();
    };

    return (
        <MerchantConfigurationContext.Provider
            value={{ isReadyToSubmit, toggleIsReadyToSubmit, warn, toggleWarn }}
        >
            <ContentBaseWrapper>
                <div className="content">
                    <Tabs
                        onTabChange={handleTabChange}
                        warnOnTabSwitch={warn}
                        initialTabIndex={platformToTabIndex[values.platform] ?? 0}
                    >
                        <Tabs.Panel index={0} title="Remita" indexKey={platforms.REMITA}>
                            <MerchantForm
                                logoUrl={merchantLogo}
                                validation={asParameterSchema(remitaFormValidation)}
                            >
                                <RemitaFormMarkup />
                            </MerchantForm>
                        </Tabs.Panel>
                        <Tabs.Panel index={1} title="Paystack" indexKey={platforms.PAYSTACK}>
                            <MerchantForm validation={asParameterSchema(paystackFormValidation)}>
                                <PaystackFormMarkup />
                            </MerchantForm>
                        </Tabs.Panel>
                        <Tabs.Panel index={2} title="Interswitch" indexKey={platforms.INTERSWITCH}>
                            <InterswitchMarkup />
                        </Tabs.Panel>

                        <Tabs.Panel index={3} title="Dreamlabs" indexKey={platforms.DREAMLABS}>
                            <MerchantForm validation={asParameterSchema(dreamlabsFormValidation)}>
                                <DreamLabsFormMarkup />
                            </MerchantForm>
                        </Tabs.Panel>
                        <Tabs.Panel index={4} title="PayPro" indexKey={platforms.PAYPRO}>
                            <MerchantForm validation={asParameterSchema(payproFormValidation)}>
                                <PayProFormMarkup />
                            </MerchantForm>
                        </Tabs.Panel>
                        <Tabs.Panel index={5} title="PayPro-Kano" indexKey={platforms.PAYPRO_KANO}>
                            <MerchantForm validation={asParameterSchema(payproKanoFormValidation)}>
                                <PayProKanoFormMarkup />
                            </MerchantForm>
                        </Tabs.Panel>
                        <Tabs.Panel index={6} title="Sokoto IRS" indexKey={platforms.SOKOTO_IRS}>
                            <MerchantForm validation={asParameterSchema(sokotoIrsFormValidation)}>
                                <SokotoIRSFormMarkup />
                            </MerchantForm>
                        </Tabs.Panel>
                    </Tabs>
                </div>
                <Stepper.StepButtons onNext={handleNextClick} />
            </ContentBaseWrapper>
        </MerchantConfigurationContext.Provider>
    );
}
